// extracted by mini-css-extract-plugin
module.exports = {"container":"eF","confirmation":"fF","print":"gF","disabled":"hF","returnLabel":"iF","returnLabels":"jF"};